import { useEffect, useState } from 'react';
import { useThemeStore, getResolvedTheme } from '@/stores/themeStore';

interface ThemeProviderProps {
  children: React.ReactNode;
}

export default function ThemeProvider({ children }: ThemeProviderProps) {
  const { theme } = useThemeStore();
  const [resolved, setResolved] = useState(() => getResolvedTheme(theme));

  // Keep the native/system choice live when the user selects "跟随系统".
  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const sync = () => setResolved(getResolvedTheme(theme));
    sync();
    if (theme === 'system') {
      media.addEventListener('change', sync);
      return () => media.removeEventListener('change', sync);
    }
  }, [theme]);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', resolved);
  }, [resolved]);

  return <>{children}</>;
}
